<template>
    <div>
        <loading :active.sync="isLoading"
                 :can-cancel="true"
                 :is-full-page="true">

        </loading>
        <div class="form-group">
            <label class="order__input-label">комментарий для склада:</label>
            <textarea v-model="comment" class="order__input"></textarea>

        </div>
        <div class="form-group">
            <button @click="sendRequest()" class="btn btn--red">Принести на розницу</button>
        </div>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "cart-bring-to-retail",
        components: {
            Loading
        },
        props: {
            'order_id': Number,
            'manager_id': Number
        },
        data () {
            return {
                order_idLocal: this.order_id,
                manager_idLocal: this.manager_id,
                comment: ''
            }
        },
        methods: {
            sendRequest () {
                this.$store.commit('setLoading', true)
                let params = new URLSearchParams();
                params.append('action', 'bring_to_retail')
                params.append('order_id', this.order_idLocal)
                params.append('manager_id', this.manager_idLocal)
                params.append('comment', this.comment)
                axios
                    .post('/rest/spec', params)
                    .then((response) => {

                        this.$store.commit('setLoading', false);
                        window.open('/user/cabinet/order/nakl?id=' + this.order_idLocal, '_blank');

                    }).catch(error => {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                })
            }
        },
        computed: {
            isLoading() {
                return this.$store.getters.loading;
            }
        },
    }
</script>

<style scoped>

</style>